<div class="wrapper-forgot-password-page">
  <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" novalidate class="content-forgot-password">
    <div class="back-btn" [routerLink]="PAGES_AND_PATHS.login.pagePath">
      <img src="../assets/icons/icon-arrow-left.svg" alt="">
    </div>
    <div class="wrapper-circle-gray-icon">
      <img src="../assets/icons/outline/icon-security.svg" alt="">
    </div>
    <div class="wrapper-header-forgot-password">
      <h6 *ngIf="!passwordChanged">{{'FORGOT_PASSWORD.set_your_new_password' | translate}}</h6>
    </div>
    <div class="change-password-text-wrap" *ngIf="!passwordChanged">
      <p>{{'FORGOT_PASSWORD.choose_a_password_that_is_easy_for_you_to_remember' | translate}}:</p>
      <ul class="bullets">
        <li>{{'FORGOT_PASSWORD.minimum_8_characters' | translate}}</li>
        <li>{{'FORGOT_PASSWORD.at_least_one_uppercase_letter' | translate}}</li>
        <li>{{'FORGOT_PASSWORD.at_least_one_number' | translate}}</li>
        <li>{{'FORGOT_PASSWORD.avoid_using_your_name_or_email' | translate}}</li>
      </ul>
      <p>{{'FORGOT_PASSWORD.make_sure_both_fields_match' | translate}}</p>
    </div>
    <div *ngIf="!passwordChanged" class="wrapper-input" [ngClass]="{'error': resetPasswordForm.controls['password'] | formControlErrorMessages: null : formTriedToSubmit}">
      <div class="custom-input">
        <input
          [type]="isPasswordVisible ? 'text' : 'password'"
          placeholder="{{'NEW_TEXT.enter_password' | translate}}"
          formControlName="password">
        <img *ngIf="!isPasswordVisible" (click)="isPasswordVisible = true" class="icon-input" src="../assets/icons/outline/icon-outline-eye.svg" alt="">
        <img *ngIf="isPasswordVisible" (click)="isPasswordVisible = false" class="icon-input" src="../assets/icons/outline/icon-outline-eye-with-slash.svg" alt="">
      </div>
      <div *ngIf="resetPasswordForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit" class="wrapper-error-message">
        <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
        <span>{{resetPasswordForm.controls['password'] | formControlErrorMessages: null: formTriedToSubmit}}</span>
      </div>
    </div>
    <div *ngIf="!passwordChanged" class="wrapper-input" [ngClass]="{'error': resetPasswordForm.controls['password_confirmation'] | formControlErrorMessagesOnSubmit: 'Passwords do not match' : formTriedToSubmit}">
      <div class="custom-input">
        <input
          [type]="isConfirmPasswordVisible ? 'text' : 'password'"
          placeholder="{{'NEW_TEXT.enter_password' | translate}}"
          formControlName="password_confirmation">
        <img *ngIf="!isConfirmPasswordVisible" (click)="isConfirmPasswordVisible = true" class="icon-input" src="../assets/icons/outline/icon-outline-eye.svg" alt="">
        <img *ngIf="isConfirmPasswordVisible" (click)="isConfirmPasswordVisible = false" class="icon-input" src="../assets/icons/outline/icon-outline-eye-with-slash.svg" alt="">
      </div>
      <div *ngIf="(resetPasswordForm.controls['password_confirmation'].errors && (formTriedToSubmit || resetPasswordForm.controls['password_confirmation'].touched))" class="wrapper-error-message">
        <img src="../assets/icons/outline/icon-outline-attention.svg" alt="">
        <span>{{resetPasswordForm.controls['password_confirmation'] | formControlErrorMessagesOnSubmit: null: formTriedToSubmit}}</span>
      </div>
    </div>
    <button *ngIf="!passwordChanged"  type="submit" class="custom-btn custom-btn--primary xs-mt-12">
      <span>{{'FORGOT_PASSWORD.save_new_password' | translate}}</span>
      <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
    </button>
    <div *ngIf="passwordChanged" class="wrapper-input">
      <span class="label-input">{{'FORGOT_PASSWORD.password_updated' | translate}}</span>
      <span class="label-input">{{'FORGOT_PASSWORD.youve_successfully_created_a_new_password' | translate}}</span>
    </div>
    <button *ngIf="passwordChanged" [routerLink]="[PAGES_AND_PATHS.login.pagePath]" class="custom-btn custom-btn--primary xs-mt-12">
      <span>{{'FORGOT_PASSWORD.go_to_login_screen' | translate}}</span>
      <tl-spinner *ngIf="isSpinnerActive"></tl-spinner>
    </button>
  </form>
</div>

